﻿class ResponsivePlaceholder {
    constructor(elm) {
        this.$elm = $(elm);

        this.defaultText = this.$elm.attr('placeholder');
        this.mediumText = this.$elm.data('placeholder-medium');

        this.setPlaceholderForBreakpoint();

        this.setEventListeners();
    }

    setEventListeners() {
        $(window).on('resize', this.onResize.bind(this));
    }

    setPlaceholder(text) {
        this.$elm.attr('placeholder', text);
    }

    setPlaceholderForBreakpoint() {
        this.setPlaceholder(
            Foundation.MediaQuery.atLeast('medium')
            ? this.mediumText
            : this.defaultText
        );
    }

    onResize(event) {
        this.setPlaceholderForBreakpoint();
    }
}

export default ResponsivePlaceholder;